import React from 'react';
import PropTypes, { arrayOf, bool, string, shape, node } from 'prop-types';
import get from 'lodash.get';
import classNames from 'classnames';

import PhoneSVG from 'dibs-vg/dist/react/phone';
import EmailSVG from 'dibs-vg/dist/react/email';
import styles from './styles/AccountUserVip.scss';

const UserVip = ({ userRelationships, header, lined }) => {
    const vipSalesRep = get(userRelationships, '[0].userDataB[0]');
    const { displayName, email, phoneNumber } = vipSalesRep;

    const containerClass = classNames(styles.container, {
        [styles.lined]: lined,
    });

    return (
        <div className={containerClass}>
            <span className={styles.header}>{header}</span>
            {displayName && <span className={styles.name}>{displayName}</span>}
            {phoneNumber && (
                <span className={styles.line}>
                    <PhoneSVG className={styles.icon} />
                    <span data-tn="account-trade-phone">{phoneNumber}</span>
                </span>
            )}
            <span className={styles.line}>
                <EmailSVG className={styles.icon} />
                {email}
            </span>
        </div>
    );
};

UserVip.propTypes = {
    header: PropTypes.oneOfType([node, string]).isRequired,
    lined: bool,
    userRelationships: arrayOf(
        shape({
            userDataB: arrayOf(
                shape({
                    displayName: PropTypes.oneOfType([node, string]),
                    email: string,
                    phoneNumber: PropTypes.oneOfType([node, string]),
                })
            ),
        })
    ).isRequired,
};

export default UserVip;
